<template>
  <div class="email_nav flex-vertical">
    <!--New Email-->
    <email-list-item
      :is-active="currentEmail.id === 'new'"
      @click="setCurrentEmail({id: 'new'})"
      is-new
    ></email-list-item>

    <!--Emails-->
    <div class="email_nav--list flex-grow">
      <email-list-item
        v-for="email in emails"
        :key="email.id"
        :email="email"
        :is-active="currentEmail.id === email.id"
        @click="setCurrentEmail(email)"
      ></email-list-item>
    </div>
  </div>
</template>

<script>
import EmailListItem from "./EmailListItem"

export default {
  name: "EmailList",
  components: {EmailListItem},
  props: {
    emails: {
      type: Array,
      required: true
    },
    currentEmail: {
      type: Object,
      required: true
    }
  },
  methods: {
    setCurrentEmail(email) {
      this.$emit('updateCurrentEmail', email);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.email_nav {
  border-right: 1px solid $borderDark;

  &--list {
    min-height: 60vh;
    overflow-y: scroll;
    border-top: 1px solid $borderDark;
  }
}
</style>
